import { render, staticRenderFns } from "./BoxHeader.vue?vue&type=template&id=66757afd&scoped=true&"
import script from "./BoxHeader.vue?vue&type=script&lang=js&"
export * from "./BoxHeader.vue?vue&type=script&lang=js&"
import style0 from "./BoxHeader.vue?vue&type=style&index=0&id=66757afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66757afd",
  null
  
)

export default component.exports